export class TimeInterval {
    id: number;
    from: Date;
    to: Date;
    standSymbol: string;
    timeIntervalStatus: string = 'nowy';
    meetingStandId: number;
}
